import { ChangeEvent, forwardRef, InputHTMLAttributes, useCallback, useEffect, useImperativeHandle, useRef } from "react";

export interface FileInputBaseProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "value" | "onChange" | "defaultValue"> {
    value: FileList | null,
    onChange: (e: ChangeEvent<HTMLInputElement>, v: FileList | null) => any,
}

const FileInputBase = forwardRef(({
    value,
    onChange,
    ...props
}: FileInputBaseProps, ref) => {
    const innerRef = useRef<HTMLInputElement>(null!);
    useImperativeHandle(ref, () => innerRef.current, []);

    const handleSetValue = useCallback((value:FileList|null)=>{
        const fileInput = innerRef.current;
        if(!fileInput) return;

        if(!value){
            fileInput.files = null;
            fileInput.value = "";
        }else{
            fileInput.files = value;
        }
    }, [innerRef.current]);

    useEffect(() => {
        handleSetValue(value)
    }, [value]);

    return <input
        ref={innerRef}
        type="file"
        onChange={e => {
            handleSetValue(e.target.files)
            onChange(e, e.target.files);
        }}
        {...props}
    />
})

export default FileInputBase;